import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { gradientToBottom } from "utils/css-utils";

interface IStylesProps {
  facilityColor?: string;
  strokeColor?: string;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    blockWrap: {
      margin: "0 -24px",
      padding: "21px 24px 25px",
      "&:last-child": {
        paddingBottom: 0
      }
    },
    nextWorkoutRequest: {
      borderBottom: "1px solid #ccc",
      paddingTop: 12,
      paddingBottom: 15,
      minHeight: 132,
      "&.flexbox": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    },
    daysOffDiagram: {
      "&__track": {
        height: 5
      },
      "&__lineChartText": {
        display: "flex",
        justifyContent: "flex-end",
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        fontSize: 18,
        marginBottom: 4
      }
    },
    notEmptyDiagram: {
      "&__track": {
        backgroundColor: primary.main
      }
    },
    daysSinceLastRace: {
      borderBottom: "1px solid #ccc"
    },
    blockTitle: {
      color: "#1a1a1a",
      fontSize: 16,
      textTransform: "capitalize"
    },
    nextWorkoutRequestTitle: {
      marginBottom: 12
    },
    daysSinceLastRaceTitle: {},
    examHistoryTitle: {
      marginBottom: 10
    },
    leftBorder: {
      backgroundImage: ({ facilityColor, strokeColor }) =>
        gradientToBottom(facilityColor, strokeColor, 5),
      width: 4,
      marginRight: 14
    },
    workoutInfoWrap: {
      display: "flex",
      marginBottom: 14
    },
    workoutDate: {
      fontSize: 16,
      color: "#333",
      fontWeight: 500,
      lineHeight: "21px"
    },
    workoutFacility: {
      fontSize: 12,
      color: primary.dark,
      lineHeight: "14px",
      textTransform: "capitalize"
    },
    creatingInfo: {
      color: primary.dark,
      fontSize: 12
    },
    commentIcon: {
      fontSize: 14,
      position: "relative",
      top: 3,
      marginRight: 6
    },
    noContent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: primary.light,
      textTransform: "capitalize"
    },
    noExams: {
      height: "calc(100vh - 384px)"
    }
  };
});
